import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Button, TextInfo } from '@components';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import { PlanoParticipanteService } from '../../../common/services/planoParticipante';

export const ValorBeneficioPage = () => {
  const [dados, setDados] = useState({
    k: '',
    valor: '',
  });

  const navigate = useNavigate();
  const { listaPlanos, plano, matricula } = useSelector((state) => state.user);

  useEffect(() => {
    const service = new PlanoParticipanteService();

    service
      .obterDadosPlanoAPorMatricula(matricula)
      .then((res) => setDados(res));
  }, [matricula]);

  const currentDate = new Date();
  const monthYear = format(currentDate, 'MM/yyyy');

  return (
    <>
      <Helmet>
        <title>Forluz - Valor do benefício</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>Valor do benefício</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="mb-3">
            <h3 className="text-orange">
              <strong>
                {listaPlanos.find((p) => p.value === plano)?.label}
              </strong>
            </h3>
            <TextInfo
              text="K - Tempo que faltava para benefício plena na data de migração de Plano"
              info={dados.k}
            />
            <TextInfo
              text="CPA - Complementação Proporcional de Aposentadoria"
              info={dados.valor}
            />
          </div>

          <hr className="mb-3" />

          <div>
            Referência - {monthYear}.
            <p className="mt-2">
              O valor apresentado trata-se de simulação de benefício pleno, ou
              seja, após cumpridas todas as exigências regulamentares, não
              existindo qualquer garantia do valor simulado.
            </p>
            <p className="mt-2">
              Nesta simulação o tempo especial (SB-40, DIRBEN, PPP) não é
              considerado. O valor real do benefício será calculado após o
              requerimento e apresentação da documentação exigida.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
